(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[245],{

/***/ 71962:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/media/news_detail/[newsId]",
      function () {
        return __webpack_require__(51957);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 51957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* export default binding */ __WEBPACK_DEFAULT_EXPORT__; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60357);
/* harmony import */ var styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_jsx_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16528);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _components_pagelay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28082);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74855);
/* harmony import */ var react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89382);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(48847);
/* harmony import */ var _utils_useDate__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19902);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81627);












// eslint-disable-next-line @typescript-eslint/no-var-requires
var showdown = __webpack_require__(53787);
var __N_SSP = true;
/* harmony default export */ function __WEBPACK_DEFAULT_EXPORT__(param) {
    var data = param.data, newsId = param.newsId;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    var converter = new showdown.Converter();
    var t = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__/* .useTranslations */ .T_)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    console.log(data);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_pagelay__WEBPACK_IMPORTED_MODULE_3__/* .PageLayout */ .X, {
            crumb: [
                {
                    path: "".concat(router.locale === "en" ? "/en" : "", "/media/news_detail/").concat(newsId),
                    name: data === null || data === void 0 ? void 0 : data.title
                }, 
            ],
            temp: "page_crumb",
            partPath: data.category_id === 1 ? "/media/news" : "/media/industry",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().container) || ""),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                                className: "jsx-1c51ad0322c4381f",
                                children: [
                                    (data === null || data === void 0 ? void 0 : data.meta_title) || "IPB国际粉体、散料、流体加工展览会",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "keywords",
                                content: (data === null || data === void 0 ? void 0 : data.meta_kws) || "IPB国际粉体、散料、流体加工展览会",
                                className: "jsx-1c51ad0322c4381f"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "description",
                                content: (data === null || data === void 0 ? void 0 : data.meta_desc) || "IPB国际粉体、散料、流体加工展览会",
                                className: "jsx-1c51ad0322c4381f"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().bg1) || "")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "jsx-1c51ad0322c4381f",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().left) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "jsx-1c51ad0322c4381f",
                                        children: data === null || data === void 0 ? void 0 : data.title
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().share) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "jsx-1c51ad0322c4381f",
                                                children: (data === null || data === void 0 ? void 0 : data.publish_time) ? Object.values((0,_utils_useDate__WEBPACK_IMPORTED_MODULE_10__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : data.publish_time)).join("-") : ""
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "jsx-1c51ad0322c4381f",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_copy_to_clipboard__WEBPACK_IMPORTED_MODULE_5__.CopyToClipboard, {
                                                    text: "".concat(_utils__WEBPACK_IMPORTED_MODULE_11__/* .PRODFORNTDOMAIN */ .zE).concat(router.locale === "en" ? "/en" : "", "/media/news_detail/").concat(newsId),
                                                    onCopy: function() {
                                                        _douyinfe_semi_ui__WEBPACK_IMPORTED_MODULE_6__/* .Notification.success */ .P_.success({
                                                            content: t("common.tips.copy"),
                                                            duration: 3
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().wx) || ""),
                                                        children: t("common.share")
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        dangerouslySetInnerHTML: {
                                            __html: converter.makeHtml(data === null || data === void 0 ? void 0 : data.content)
                                        },
                                        className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().content) || "")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().footer) || ""),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().links) || ""),
                                                children: [
                                                    (data === null || data === void 0 ? void 0 : data.last_news) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: (data === null || data === void 0 ? void 0 : (ref = data.last_news) === null || ref === void 0 ? void 0 : ref.url) ? data === null || data === void 0 ? void 0 : (ref1 = data.last_news) === null || ref1 === void 0 ? void 0 : ref1.url : "".concat(router.locale === "en" ? "/en" : "", "/media/news_detail/").concat(data === null || data === void 0 ? void 0 : (ref2 = data.last_news) === null || ref2 === void 0 ? void 0 : ref2.id),
                                                        className: "jsx-1c51ad0322c4381f",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "jsx-1c51ad0322c4381f",
                                                            children: [
                                                                t("news.prev"),
                                                                "：",
                                                                data === null || data === void 0 ? void 0 : (ref3 = data.last_news) === null || ref3 === void 0 ? void 0 : ref3.info_title
                                                            ]
                                                        })
                                                    }),
                                                    (data === null || data === void 0 ? void 0 : data.next_news) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: (data === null || data === void 0 ? void 0 : (ref4 = data.next_news) === null || ref4 === void 0 ? void 0 : ref4.url) ? data === null || data === void 0 ? void 0 : (ref5 = data.next_news) === null || ref5 === void 0 ? void 0 : ref5.url : "".concat(router.locale === "en" ? "/en" : "", "/media/news_detail/").concat(data === null || data === void 0 ? void 0 : (ref6 = data.next_news) === null || ref6 === void 0 ? void 0 : ref6.id),
                                                        className: "jsx-1c51ad0322c4381f",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                            className: "jsx-1c51ad0322c4381f",
                                                            children: [
                                                                t("news.next"),
                                                                "：",
                                                                data === null || data === void 0 ? void 0 : (ref7 = data.next_news) === null || ref7 === void 0 ? void 0 : ref7.info_title
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                style: {
                                                    gap: router.locale === "cn" ? "60px" : "30px"
                                                },
                                                href: data.category_id === 1 ? "".concat(router.locale === "en" ? "/en" : "", "/media/news") : "".concat(router.locale === "en" ? "/en" : "", " /media/industry"),
                                                className: "jsx-1c51ad0322c4381f",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "jsx-1c51ad0322c4381f",
                                                        children: t("news.return")
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                        className: "jsx-1c51ad0322c4381f"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().right) || ""),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "jsx-1c51ad0322c4381f",
                                        children: t("news.recomm")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "jsx-1c51ad0322c4381f",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                            className: "jsx-1c51ad0322c4381f",
                                            children: data === null || data === void 0 ? void 0 : (ref8 = data.recommend_news_list) === null || ref8 === void 0 ? void 0 : ref8.map(function(item) {
                                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: item.url ? item.url : "".concat(router.locale === "en" ? "/en" : "", "/media/news_detail/").concat(item.id),
                                                    target: "_blank",
                                                    className: "jsx-1c51ad0322c4381f",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().imgBox) || ""),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                onError: function(e) {
                                                                    return e.target.src = "http://admin.ipbexpo.com/uploads/editor/20250421/1d158468348e36f262393b6ff2b0d00e.jpg";
                                                                },
                                                                src: item.show_image,
                                                                loading: "lazy",
                                                                alt: "",
                                                                className: "jsx-1c51ad0322c4381f"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().info) || ""),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "jsx-1c51ad0322c4381f" + " " + ((_styles_module_scss__WEBPACK_IMPORTED_MODULE_9___default().title) || ""),
                                                                    children: item.info_title
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "jsx-1c51ad0322c4381f",
                                                                    children: (data === null || data === void 0 ? void 0 : data.publish_time) ? Object.values((0,_utils_useDate__WEBPACK_IMPORTED_MODULE_10__/* .useDate */ .Y)(data === null || data === void 0 ? void 0 : data.publish_time)).join("-") : ""
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                });
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((styled_jsx_style__WEBPACK_IMPORTED_MODULE_1___default()), {
                        id: "1c51ad0322c4381f",
                        children: ".semi-typography{max-width:600px!important}"
                    })
                ]
            })
        })
    });
};


/***/ }),

/***/ 48847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "sC": function() { return /* binding */ PRODDOMAIN; },
/* harmony export */   "zE": function() { return /* binding */ PRODFORNTDOMAIN; }
/* harmony export */ });
/* unused harmony export DEVDOMAIN */
var DEVDOMAIN = "http://localhost:3001";
// export const PRODDOMAIN = "http://system.icef.com.cn";
var PRODDOMAIN = "https://admin.ipbexpo.com";
var PRODFORNTDOMAIN = "http://ipbexpo.smartinfo.cn"; // export const PRODDOMAIN = "http://cbce.smartinfo.cn";


/***/ }),

/***/ 19902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useDate; }
/* harmony export */ });
var useDate = function(date) {
    var time = new Date(String(date).length === 10 ? date * 1000 : date);
    return {
        year: time.getFullYear() || "",
        month: (time.getMonth() + 1 < 10 ? "0" + (time.getMonth() + 1) : time.getMonth() + 1) || "",
        day: (time.getDate() < 10 ? "0" + time.getDate() : time.getDate()) || ""
    };
};



/***/ }),

/***/ 16528:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Buga7","bg1":"styles_bg1__ldXn5","left":"styles_left__CaDxz","share":"styles_share__2RuZo","wx":"styles_wx__IEwNv","footer":"styles_footer__RvAEN","links":"styles_links__l0_Ss","right":"styles_right__o2K0V","imgBox":"styles_imgBox__yZicf","info":"styles_info__N5Zxe","title":"styles_title__IXRb6"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [222,43,912,774,888,179], function() { return __webpack_exec__(71962); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);